import { Pipe, PipeTransform } from '@angular/core';
interface MovimentoStock {
  codArmazem: string;
  codArtigo: string;
  codDocumento: string;
  codEmpresa: string;
  codMovimento: string;
  dataCriacao: Date | string;
  dataMovimento: Date | string;
  idArmazem: number;
  idArtigo: number;
  idEmpresa: number;
  idMovimento: number;
  movimento: string;
  nomeArtigo: string;
  preco: number;
  quantidade: number;
  total: number;
  unidadeMedida: string;
  url: string;
  utilizador: any;
  cliente: any;
}
@Pipe({
  name: 'tabStockTotal',
  pure: true
}) export class TabStockTotalPipe implements PipeTransform {
transform(dados: any[] = [], codMov?: string, propKey?: string) {
let movimentos: MovimentoStock[] = [];
let total = 0;
if (dados && dados.length && dados.length > 0) {
    movimentos = dados.filter(m => m.codMovimento === codMov);
    total = movimentos.reduce((a, obj) => {
      return a + obj[propKey];
    }, 0);
}
 return total;
}

}
